module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "id": "ch10"
    }
  }), _vm._v("POCAHONTAS, 1610")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("F")]), _vm._v("ew figures have captured the American imagination as has the Powhatan Indian woman, Matoaka, or as she is popularly known, Pocahontas. From the moment that, as a thirteen-year-old, she intervened and, by his testimony, saved the life of Captain John Smith, Pocahontas was a Jamestown fixture. Baptized as Rebecca, she was married in 1614 to John Rolfe, an early developer of Virginia’s tobacco industry. She helped bring a measure of peace to the region.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1614, John and Rebecca went to England to recruit new settlers for the colony. Soon this gracious and charming young Indian woman had transfixed London society. She attended the theater, gala balls, and many dinners given in her honor; was entertained by the Bishop of London; and received at the court of King James I. The Rolfes conveyed such a positive impression that the English shifted in a more conciliatory direction in its dealings with Native Americans. "), _c('span', {
    staticClass: "color"
  }, [_vm._v("(03-059, 03-060)")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img23.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c326440","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter010.vue
// module id = 105
// module chunks = 0